export interface BackendResponse {
  data: any;
}

export class ErrorModel {
  status!: number;
  statusText!: string;
  message!: string;

  constructor(fields: { status?: number, statusText?: string, message?: string }) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}
